import { useDatabasePage } from "./hooks/use-database-page";
import { useAppModals } from "../../app/state/modalSlice/hook/use-app-modals";
import { SelectDatabaseModal } from "../../features/Database/Components/SelectDatabaseModal";
import { Sidebar } from "../../common/AppSidebar";
import { APP_VECTOR_STORE_MODE } from "../../services/api/constants";
import { SafeOutlet } from "../../common/Protectors/SafeOutlet";
import styles from "./styles.module.css";

export const DatabasePage = () => {
  const {
    storeSidebarItems,
    isLoading,
    selectedStore,
    handleCreateStore,
    handleSelectDatabase,
  } = useDatabasePage();
  const { handleOpenModal, handleCloseModal } = useAppModals();

  const onCreateStore = () => {
    APP_VECTOR_STORE_MODE === "both"
      ? handleOpenModal("select_database_modal", null)
      : handleCreateStore(APP_VECTOR_STORE_MODE);
  };

  return (
    <div className={styles["page-layout"]}>
      <Sidebar
        menuItems={storeSidebarItems}
        onAdd={onCreateStore}
        onSelect={handleSelectDatabase}
        selectedId={selectedStore?.id ?? ""}
        service={"knowledge_base"}
        isLoading={isLoading ?? false}
        withoutAddFolderButton
        withoutActions
      />
      {selectedStore && <SafeOutlet />}
      <SelectDatabaseModal
        closeModal={handleCloseModal}
        createStore={handleCreateStore}
      />
    </div>
  );
};
